const path = 'PrivacyPolicyModule';
const apiPath = '/admin-panal/policy-versions';

const PrivacyPolicyActions = {
  GET_PRIVACY_POLICY: `${path}/getPrivacyPolicy`,
  UPDATE_PRIVACY_POLICY : `${path}/updatePrivacyPolicy`,
}


const PrivacyPolicyAPIsConstants = {
  API_PATH : `${apiPath}`,
  GET_API_PATH : `${apiPath}/privacy`,
}

export { PrivacyPolicyActions, PrivacyPolicyAPIsConstants, path as ModuleName };
